import { render, staticRenderFns } from "./ViewProducts.vue?vue&type=template&id=1847292d&"
import script from "./ViewProducts.vue?vue&type=script&lang=js&"
export * from "./ViewProducts.vue?vue&type=script&lang=js&"
import style0 from "./ViewProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports